import { GRAVITY_WEBSITE_HANDOFF_READY_EVENT, GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY } from './gravityWebsiteHandoffConstants.js';
import { clearRememberedGravityWebsiteHandoffId } from './gravityWebsiteHandoffMemory.js';
import clearGravityWebsiteHandoff from './clearGravityWebsiteHandoff.js';
import isGravityWebsiteHandoffId from './isGravityWebsiteHandoffId.js';
import persistGravityWebsiteHandoff from './persistGravityWebsiteHandoff.js';
import readGravityWebsiteHandoff from './readGravityWebsiteHandoff.js';

const markGravityWebsiteHandoffReady = (expectedHandoffId = '') => {
  const handoffId = String(expectedHandoffId || '').trim();

  if (!isGravityWebsiteHandoffId(handoffId) || typeof window === 'undefined') {
    clearGravityWebsiteHandoff();
    return '';
  }

  clearRememberedGravityWebsiteHandoffId(handoffId);

  let handoff = readGravityWebsiteHandoff();
  if (handoff?.handoffId !== handoffId) {
    clearGravityWebsiteHandoff();
    persistGravityWebsiteHandoff(handoffId);
    handoff = readGravityWebsiteHandoff();
  }

  try {
    const storage = window.sessionStorage;
    if (storage && handoff?.handoffId === handoffId) {
      storage.setItem(
        GRAVITY_WEBSITE_HANDOFF_STORAGE_KEY,
        JSON.stringify({
          ...handoff,
          ready: true
        })
      );
    }
  } catch {
    // The in-memory ready event still lets this page attempt delivery.
  }

  window.dispatchEvent(
    new CustomEvent(GRAVITY_WEBSITE_HANDOFF_READY_EVENT, {
      detail: {
        handoffId
      }
    })
  );
  return handoffId;
};

export default markGravityWebsiteHandoffReady;
